import { useCallback, useEffect, useState } from "react";
import { App as CapacitorApp } from "@capacitor/app";
import { Capacitor } from "@capacitor/core";
import { Geolocation } from "@capacitor/geolocation";

function getAndroidGPSPlugin() {
  const plugins = window?.Capacitor?.Plugins || Capacitor?.Plugins || {};
  return plugins.GPSNative || plugins.GPSNativePlugin || null;
}

export default function LocationDisabledNotice() {
  const [reason, setReason] = useState(null);

  const checkLocation = useCallback(async () => {
    if (!Capacitor.isNativePlatform()) return;

    try {
      if (Capacitor.getPlatform() === "android") {
        const plugin = getAndroidGPSPlugin();
        if (typeof plugin?.getLocationAvailability === "function") {
          const status = await plugin.getLocationAvailability();
          setReason(
            !status?.servicesEnabled
              ? "services"
              : !status?.permissionGranted
                ? "permission"
                : null
          );
          return;
        }
      }

      const permission = await Geolocation.checkPermissions();
      setReason(permission?.location === "denied" ? "permission" : null);
    } catch {
      // A verificação não deve impedir a abertura da app.
    }
  }, []);

  useEffect(() => {
    void checkLocation();
    let appStateListener;

    const registerListener = async () => {
      appStateListener = await CapacitorApp.addListener("appStateChange", ({ isActive }) => {
        if (isActive) void checkLocation();
      });
    };
    void registerListener();

    return () => {
      appStateListener?.remove?.();
    };
  }, [checkLocation]);

  const openSettings = async () => {
    try {
      const plugin = getAndroidGPSPlugin();
      if (Capacitor.getPlatform() === "android" && plugin?.openLocationSettings) {
        await plugin.openLocationSettings();
        return;
      }

      // iOS reconhece este URL como o ecrã de definições da aplicação.
      window.location.href = "app-settings:";
    } catch {
      // Mantém o aviso aberto para o utilizador poder voltar a tentar.
    }
  };

  if (!reason) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="location-disabled-title"
      style={{
        position: "absolute",
        inset: 0,
        zIndex: 12000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 20,
        background: "rgba(8, 15, 10, 0.58)",
      }}
    >
      <div
        style={{
          width: "min(430px, 100%)",
          padding: 22,
          borderRadius: 18,
          background: "#fff",
          boxShadow: "0 24px 60px rgba(17, 54, 31, 0.28)",
          textAlign: "center",
        }}
      >
        <div aria-hidden="true" style={{ fontSize: 38, marginBottom: 8 }}>📍</div>
        <h2
          id="location-disabled-title"
          style={{ margin: "0 0 10px", color: "#1a5f35", fontSize: 22 }}
        >
          Localização desativada
        </h2>
        <p style={{ margin: "0 0 18px", color: "#46534a", lineHeight: 1.5 }}>
          {reason === "services"
            ? "Ativa a localização do dispositivo para veres a tua posição e usares todas as funcionalidades da Trekkin."
            : "Permite o acesso à localização para veres a tua posição e usares todas as funcionalidades da Trekkin."}
        </p>
        <div style={{ display: "flex", justifyContent: "center", gap: 10, flexWrap: "wrap" }}>
          <button
            type="button"
            onClick={openSettings}
            style={{
              border: 0,
              borderRadius: 11,
              padding: "11px 16px",
              background: "#1f8f48",
              color: "#fff",
              fontWeight: 700,
            }}
          >
            Ir às definições
          </button>
          <button
            type="button"
            onClick={() => setReason(null)}
            style={{
              border: "1px solid #c8d8ca",
              borderRadius: 11,
              padding: "11px 16px",
              background: "#f6faf7",
              color: "#254734",
              fontWeight: 600,
            }}
          >
            Agora não
          </button>
        </div>
      </div>
    </div>
  );
}
